import React, { Component } from "react";
import { bindActionCreators } from "redux";
import withRedux from "next-redux-wrapper";
import withReduxSaga from "next-redux-saga";
import Head from "next/head";
import PropTypes from "prop-types";
// import styled from "styled-components";
import Store from "store";
import { fetchTag } from "store/posts/actions";
// import { Link } from "routes";
import NProgress from "components/NProgress";
// import Header from '../container/DefaultLayout/header';
// import Icon from '@material-ui/core/Icon';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import NewsItem from "/components/News/NewsItem";
import { DFPSlotsProvider, AdSlot, DFPManager } from 'react-dfp';
import { Router } from "routes";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Axios from "/plugins/axios";
// import Footer from "/container/DefaultLayout/footer.js";
// import Headroom from "react-headroom";
// import BrandsSlider from '/components/brandsSlider';
// import TagManager from 'react-gtm-module'
import Hidden from '@material-ui/core/Hidden';
// import MobileNewsItem from "/components/Mobile/MobileNewsItem";
// import DesktopNewsItem from "/components/Desktop/DesktopNewsItem";
import ThereIsNoArticle from "/components/thereIsNoArticle";
import fontUniOrConvertZawgyi from '/utils/fontUniOrConvertZawgyi';
import getAdSlotByDevicePosition from "../utils/ads";
import ContentTitle from "/components/contentTitle";
import VideoCardPoster from "/components/Video/VideoCardPoster";
import VideoCardParts from '/components/Video/VideoCardParts';
import ResultItems from "/components/resultItems";
import TagAllItem from "/components/Tag/TagAllItem";
import SeoMeta from '/components/seoMeta';
import {getFooterTopOffset, infiniteHandleScroll} from '/components/NextMore/infiniteHandleScroll';
import { capitalizeLetter, duwunCoverLogo } from '/utils/common';
// const tagManagerArgs = {
//   dataLayer: {}
// }

const styles = theme => ({
  root: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden',
      // backgroundColor: theme.palette.background.paper,
  },
  img: {
      width: '100%',
      height: 250,
      objectFit: 'cover'
  },
  titleBar: {
      backgroundColor: 'transparent'
  },
  title: {
      backgroundColor: '#0A0A0A',
      padding: '4px 8px'
  },

  gridList: {
     height: 'auto'
  },
  divider: {
      width: '90%',
      height: 1.5,
      marginTop: 35,
      top: '20',
      border: 'none',
      backgroundColor: '#c1bcbc!important'
  },
  icon: {
      color: 'white',
  },
  button: {
      margin: '13px 0px 23px',
      paddingLeft: 25,
      letterSpacing: '1px'
  },
  layout: {
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.up('sm')]: {
        width: 900,
    },
    [theme.breakpoints.only('sm')]: {
        width: 650,
        padding: '0px 20px'
    },
    [theme.breakpoints.only('xs')]: {
        padding: '0px 20px'
    },
},

});

class TagItem extends Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false,
      newsItems: [],
      count: 1,
      next: this.props.links.next,
      url: this.props.url,
      ssrDone: false,
      adMobileTop:{
            id: 'div-gpt-ad-top-0',
            networkId: null,
            adUnit: null,
            adSizes: [[300, 250]],
            mobile: true,
            position: 'TOP',
            targetingArguments: null,
        },
      adMobileMiddle:{
            id: 'div-gpt-ad-middle-0',
            networkId: null,
            adUnit: null,
            adSizes: [[300, 250]],
            mobile: true,
            position: 'MIDDLE',
            targetingArguments: null,
        },
      adMobileBottom:{
            id: 'div-gpt-ad-bottom-0',
            networkId: null,
            adUnit: null,
            adSizes: [[300, 250]],
            mobile: true,
            position: 'BOTTOM',
            targetingArguments: null,
        },
      adMobileBottomRotate:{
            id: 'div-gpt-ad-bottom-1',
            networkId: null,
            adUnit: null,
            adSizes: [[300, 250]],
            mobile: true,
            position: 'ROTATE',
            targetingArguments: null,
        },
      adDesktopTop:{
            id: 'div-gpt-ad-desktop-global',
            networkId: null,
            adUnit: null,
            adSizes: [[970, 250]],
            mobile: false,
            position: 'TOP',
            targetingArguments: null,
        },
      adDesktopMiddle:{
            id: 'div-gpt-ad-desktop-middle',
            networkId: null,
            adUnit: null,
            adSizes: [[970, 250]],
            mobile: false,
            position: 'MIDDLE',
            targetingArguments: null,
        },
      adDesktopBottom:{
            id: 'div-gpt-ad-desktop-bottom-0',
            networkId: null,
            adUnit: null,
            adSizes: [[970, 250]],
            mobile: false,
            position: 'BOTTOM',
            targetingArguments: null,
        },
      adDesktopBottomRotate:{
            id: 'div-gpt-ad-desktop-bottom-1',
            networkId: null,
            adUnit: null,
            adSizes: [[970, 250]],
            mobile: false,
            position: 'ROTATE',
            targetingArguments: null,
        }
    };
    this.handleScroll = infiniteHandleScroll.bind(this, this);
    // this.handleScroll = this.handleScroll.bind(this);
  }

  static getInitialProps({ query, asPath, store }) {
    const { tag } = query;
    const currentDateTime = new Date().toISOString();
    store.dispatch(fetchTag(tag, currentDateTime));
    return { tag, asPath, currentDateTime };
  }

nextPage = (url) => {
    // const nextPerPage = isMobile ? 6 : 8
    url = `/tags/${this.props.url.query.tag}?type=all&exclude=body&published_date=${this.props.currentDateTime}&perPage=8&${  url.split('?').length > 0 ? `&${  url.split('?')[1]}` : ''}`;
    this.setState({
        loading: true
     });
    Axios.get(url)
        .then(res => {
            res.data.data.map((value) => this.state.newsItems.push(value))
            this.setState({
                newsItems: this.state.newsItems,
                next: res.data.links.next,
                url: this.props.url,
                loading: false,
               })
        })
}
__nextBtn () {
    const {classes, uniReadable} = this.props;
    if(this.state.next != null) {
        return (
          <div style={{textAlign: 'center', marginTop: 10}}>
            <Button
              variant="contained"
              color="primary"
              style={{boxShadow: 'none', fontWeight: 'bold', borderRadius: 50}}
              className={classes.button}
              onClick={() => !this.state.loading ? this.nextPage(this.state.next) : null}
            >
              <span>
                {
                    uniReadable ? 'နောက်ထပ်':  'ေနာက္ထပ္'
                }
              </span>
              {this.state.loading ?
                <div className="ld ld-ring ld-spin" style={{marginLeft: 5, marginRight: 5}} />
                    :
                <div style={{display: 'inline-flex'}}>
                  <Icon>keyboard_arrow_down</Icon>
                </div>
                 }
            </Button>

          </div>
        )
    }
}

__getDfpAds = (index) => {
    const { ads } = this.props;
    const adMobileBottomRotate = ads ? getAdSlotByDevicePosition(true, ads, this.state.adMobileBottomRotate.position) : null;
    const adDesktopBottomRotate = ads ? getAdSlotByDevicePosition(false, ads, this.state.adDesktopBottomRotate.position) : null;
    const ssrDone = this.state.ssrDone;
      <div className='ads-style'>
        <Hidden only={['md', 'lg', 'xl']}>
          {/* <MobileView> */}
          {
                    ads && ssrDone && adMobileBottomRotate.id &&
                    <AdSlot
                      sizes={adMobileBottomRotate.adSizes}
                      dfpNetworkId={adMobileBottomRotate.networkId}
                      adUnit={adMobileBottomRotate.adUnit}
                      // targetingArguments={adMobileBottomRotate.targetingArguments}
                      shouldRefresh={()=> true}
                        // slotId={adMobileBottomRotate.id}
                    />
                    }
          {/* </MobileView> */}
        </Hidden>
        <Hidden smDown>
          {/* <BrowserView> */}
          {
                     ads && ssrDone && adDesktopBottomRotate.id &&
                    <AdSlot
                      sizes={adDesktopBottomRotate.adSizes}
                      dfpNetworkId={adDesktopBottomRotate.networkId}
                      adUnit={adDesktopBottomRotate.adUnit}
                      shouldRefresh={()=> true}
                        // slotId={adDesktopBottomRotate.id}
                    />
                    }
          {/* </BrowserView> */}
        </Hidden>
      </div>
  }

render() {
    const { tags, links, categories, classes, ads, brands } = this.props;
    const {newsItems} =this.state;

    const adMobileTop = ads ? getAdSlotByDevicePosition(true, ads, this.state.adMobileTop.position) : null;
    const adMobileMiddle = ads ? getAdSlotByDevicePosition(true, ads, this.state.adMobileMiddle.position) : null;
    const adMobileBottom = ads ? getAdSlotByDevicePosition(true, ads, this.state.adMobileBottom.position) : null;
    const adDesktopTop = ads ? getAdSlotByDevicePosition(false, ads, this.state.adDesktopTop.position) : null;
    const adDesktopMiddle = ads ? getAdSlotByDevicePosition(false, ads, this.state.adDesktopMiddle.position) : null;
    const adDesktopBottom = ads ? getAdSlotByDevicePosition(false, ads, this.state.adDesktopBottom.position) : null;

    const ssrDone = this.state.ssrDone;
    const queryTagName = `${this.props.url.query.tag}`
    const tagNameCapitalize = capitalizeLetter(queryTagName);
    const tagName = queryTagName == 'covid-19' ? 'COVID-19' : tagNameCapitalize;
    const description = queryTagName == 'covid-19' ? 'Read the latest updates on Coronavirus in Myanmar and around the world. Exclusive statistics, insights and more.' : `Read the latest updates on ${tagNameCapitalize}. Exclusive videos, photos and more.`
    return (
      <div>
        <Head>
          <title>{`${tagName} | Duwun`}</title>
        </Head>
        <SeoMeta
            url={`${process.env.BACKEND_URL}${this.props.asPath}`}
            type="article"
            title={`${tagName} | Duwun`}
            description={description}
            image={duwunCoverLogo}
            section={this.props.url.query.tag}
            keywords={this.props.url.query.tag}
          />        
        <NProgress />

        <div className='ads-global-style'>
          <Hidden only={['md', 'lg', 'xl']}>
            <div style={{textAlign : 'center'}}>
              {
                         ads && ssrDone && adMobileTop.id &&
                        <AdSlot
                          sizes={adMobileTop.adSizes}
                          dfpNetworkId={adMobileTop.networkId}
                          adUnit={adMobileTop.adUnit}
                          shouldRefresh={()=> true}
                          // slotId={adMobileTop.id}
                        />
                    }
            </div>
          </Hidden>
          <Hidden smDown>
            <div style={{textAlign : 'center'}}>
              {
                         ads && ssrDone && adDesktopTop.id &&
                        <AdSlot
                          sizes={adDesktopTop.adSizes}
                          dfpNetworkId={adDesktopTop.networkId}
                          adUnit={adDesktopTop.adUnit}
                          targetingArguments={adDesktopTop.targetingArguments}
                          shouldRefresh={()=> true}
                          // slotId={adDesktopTop.id}
                        />
                    }
            </div>
          </Hidden>
        </div>

        {/* <div className={classes.root} style={{marginBottom: 20}}> */}
        <Hidden only={['md', 'lg', 'xl']}>
          {/* <MobileView> */}
          <div className={classes.root}>
            <div className='mobileLayout'>
              <div style={{ marginBottom: 10}}>
                <ContentTitle noCapitalize contentTitle={fontUniOrConvertZawgyi(tagName)} color="#000" typoComponent="h1" />
              </div>
              {tags.length == 0 ?
                <ThereIsNoArticle />  :
                <React.Fragment>
                  {tags.length > 0 && tags.map((item, index) => (
                      <React.Fragment key={index}>
                        <TagAllItem item={item} />
                      </React.Fragment>
                      ))}
                </React.Fragment>
                  }

              {newsItems && newsItems.map((item, index) => (
                <React.Fragment key={index} >
                   <TagAllItem item={item} />
                </React.Fragment>
                  ))}
              { links.next ?  this.__nextBtn() : null}

            </div>
          </div>
          {/* </MobileView> */}
        </Hidden>
        <Hidden smDown>
          {/* <BrowserView> */}
          <div className={classes.root}>
            <div className={classes.layout}>
              <Grid container>
                <ContentTitle noCapitalize contentTitle={fontUniOrConvertZawgyi(tagName)} color="#000" typoComponent="h1" />
              </Grid>
              {tags.length == 0 ?
                <ThereIsNoArticle />  :
                <div>
                  {tags.map((item, index) => {
                    let poster = item.media_id ? this.props.width === 'xs' ? item.posters.video_section_teaser : item.posters.thumb : null
                      return (
                        <React.Fragment key={index}>
                          <TagAllItem item={item} />
                      </React.Fragment>
                    )
                  })}
                </div>
              }
              {newsItems && newsItems.map((item, index) => {
                  let poster = item.media_id ? this.props.width === 'xs' ? item.posters.video_section_teaser : item.posters.thumb : null
                    return (
                      <React.Fragment key={index}>
                        <TagAllItem item={item} />
                      </React.Fragment>
                    )
                    })}
              { links.next ?  this.__nextBtn() : null}
            </div>
          </div>
          {/* </BrowserView> */}

        </Hidden>

      </div>
    );
}
    componentDidMount () {
        window.DFPManagerLoaded = false;
        this.setState({
            ssrDone: true,
            // next: this.props.links.next
        });
        this.previousFooterTopOffset = getFooterTopOffset();
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    // handleScroll(that, event) {
    //   if(window.pageYOffset > 200 && !this.pageFiveLoaded) {
    //     if(this.state.next != null && !this.state.loading) {
    //       this.nextPage(this.state.next);
    //     }
    //     let nextApi = this.state.next;
    //     let endInfiniteScroll = nextApi != null && nextApi.includes("page=5");
    //     if(endInfiniteScroll){
    //       this.pageFiveLoaded = true;
    //     }
    //   }
    // }
    componentDidUpdate(previousProps, previousState){
        // const categorySegment = this.props.url.query.tag;
        DFPManager.setTargetingArguments({'section': 'home' });
        // DFPManager.refresh();
        // DFPManager.load();
        DFPManager.configureLazyLoad(true);
        DFPManager.configureDisableInitialLoad(true);
        // ref: https://developers.google.com/publisher-tag/guides/control-ad-loading
        
        DFPManager.setCollapseEmptyDivs(true);     
        if (!window.DFPManagerLoaded)
          DFPManager.load();
        window.DFPManagerLoaded = true;   
        DFPManager.refresh();          
        
        // TagManager.dataLayer(tagManagerArgs)

        let nextPage = this.state.next != null && this.state.next.split('?').length > 0 ? this.state.next.split('?')[1] : '';
        this.nextPageNumber = nextPage.split('page=').length > 0 ? parseInt(nextPage.split('page=')[1]) : 0;

        if(previousProps.url.query.tag != this.props.url.query.tag) {
          this.initialPageLoaded = false;
          this.nextPageNumber = 2;
        }

        {/* ***** showMore and infiniteScroll Events ***** */}
        if(this.state.ssrDone && !this.state.loading) {
          const currentPageNumber = this.nextPageNumber ? this.nextPageNumber-2 : 0;
          const pageUrl = document.location.origin + document.location.pathname;
          const showMorePagePath = currentPageNumber <= 1 ? pageUrl : pageUrl + "#page-" + currentPageNumber;          
          if(currentPageNumber > 1) {  
            window.parent.location.hash = "page-" + currentPageNumber;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'showMoreEvent',
                showMoreEventPage: showMorePagePath,
                showMoreEventTitle: this.props.url && this.props.url.query.tag ? "tags/" + this.props.url.query.tag : 'No Title'
            });            
          }          
        }

        this.newFooterTopOffset = getFooterTopOffset();
    }
}

TagItem.propTypes = {
  classes: PropTypes.object.isRequired,
  tags: PropTypes.arrayOf(PropTypes.object).isRequired,
//   brands: PropTypes.arrayOf(PropTypes.object).isRequired
};

const mapStateToProps = state => ({
  tags: state.posts.tag.data,
  links: state.posts.tag.links,
  ads: state.posts.tag.ads,
//   brands: state.posts.brands
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchTag,
    //   fetchBrands
    },
    dispatch
  );

export default withRedux(Store, mapStateToProps, mapDispatchToProps)(
  withReduxSaga(withStyles(styles)(TagItem))
);
